// src/admin/components/FinancialMetric.jsx
//
// A small reusable label + value pair used throughout financial sections
// (cost breakdown, camp info grid, KPI sub-values, etc).

import React from 'react';

export default function FinancialMetric({
  label,
  value,
  valueClassName = 'text-[#172B2B]',
  align = 'right',
  size = 'md',
}) {
  const sizeClass = size === 'lg' ? 'text-lg' : size === 'sm' ? 'text-xs' : 'text-sm';

  return (
    <div
      className={`flex items-center gap-3 ${
        align === 'right' ? 'justify-between' : 'flex-col items-start gap-1'
      }`}
    >
      <span className="text-xs font-medium text-[#6B7C7C]">{label}</span>
      <span className={`${sizeClass} font-semibold tabular-nums ${valueClassName}`}>
        {value}
      </span>
    </div>
  );
}
